module.exports = __webpack_public_path__ + "img/E06-en-arup-climate-risk-images.6aa0aea9.jpg";